(function () {
  const announcementSlider = () => {
    $(".announcement-bar__slide").each(function () {
      if ($(this).hasClass("slider_started")) {
        return "";
      }
      if ($(".announcement-bar")) {
        $(this).addClass("slider_started");
      }

      const announcementId = $(this).data("announcement-id");
      const announcementSwiper = new Swiper(
        `.announcement-js-${announcementId}`,
        {
          loop: false,
          navigation: {
            nextEl: `#shopify-section-${announcementId} .announcement-btn-next`,
            prevEl: `#shopify-section-${announcementId} .announcement-btn-prev`,
          },
        }
      );
    });
  };

  let announcementObserver = null;

  const syncAnnouncementHeight = () => {
    const root = document.documentElement;
    const announcementBar = document.querySelector(".announcement-bar");

    if (announcementObserver) {
      announcementObserver.disconnect();
      announcementObserver = null;
    }

    if (!announcementBar) {
      root.style.removeProperty("--announcement-height");
      return;
    }

    const setHeight = () => {
      root.style.setProperty(
        "--announcement-height",
        `${announcementBar.offsetHeight}px`
      );
    };

    setHeight();
    if ("ResizeObserver" in window) {
      announcementObserver = new ResizeObserver(setHeight);
      announcementObserver.observe(announcementBar);
    }
  };

  announcementSlider();
  syncAnnouncementHeight();
  document.addEventListener("shopify:section:load", function () {
    announcementSlider();
    syncAnnouncementHeight();
  });
  document.addEventListener("shopify:section:unload", function (event) {
    if (event.target.querySelector(".announcement-bar")) {
      setTimeout(syncAnnouncementHeight);
    }
  });
})();
